import { Grid } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import GetAsignaturas from "../../data/GetAsignaturas";
import GetNiveles from "../../data/GetNiveles";
import AjustesYApoyos from "../../components/Form/Fields/AjustesYApoyos";
import Caracterizacion from "../../components/Form/Fields/Caracterizacion";
import CondicionesContexto from "../../components/Form/Fields/CondicionesContexto";
import TemaClase from "../../components/Form/Fields/TemaClase";
import TiempoClase from "../../components/Form/Fields/TiempoClase";
import PlanificacionDiferenciadaCardImg from "../../components/UmmIApps/Cards/PlanificacionDiferenciada.png";
import GetObjetivosAprendizaje from "../../components/ObjetivosAprendizaje/GetObjetivosAprendizaje";
import { UseSetLenguajePorPais } from "../../hooks/UseSetLenguajePorPais";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";
import UmmiaAppsLayout from "../../components/UmmIACategories/Layout/UmmiaAppsLayout";
import { useAuthContext } from "../../hooks/Auth";
import { OASProvider } from "../../context/SuperAdmin/OASContexts/OASContext";
import CurriculumTabs from "../../components/CurriculumTabs/CurriculumTabs";
import { isSendButtonDisabled } from "../../config/sendButtonRules";

const ClaseDiferenciadaPage = () => {
  const { t } = useTranslation(); // Hook de traducción

  //Hook para lenguaje según país
  UseSetLenguajePorPais();

  const {
    nivelId,
    materiaId,
    promptData,
    handleBack,
    setTextoInicial,
    isOAAdded,
    handleNivelChange,
    handleAsignaturaChangeLocal,
    handleInitialPromptData,
    handleNivelTPChange,
    handleAsignaturaTPChangeLocal,
    clearTP,
    setPromptData,
    nivelTPId,
    asignaturaTPId,
  } = useActividadesContext();

  const { user } = useAuthContext();

  //Variable para condicionar la habilitación del botón "Generar"
  const isButtonDisabled =  isSendButtonDisabled("planificacion", { promptData });
  const colorIconBack = "#278C62";

  useEffect(() => {
    const init = {
      tiempo_clase: 45,
      tema: "",
      caracterizacion: "",
      necesidades_educativas: "",
      condiciones_contexto: "",
    };
    handleInitialPromptData(init, "planificacion");
    setTextoInicial(
      "Esta es la propuesta que tengo para ti.  Puedes revisarla y modificar cualquier parte según tus necesidades. Ajusta los parámetros en 'Mostrar campos', genera una nueva versión con 'Volver a generar' o personaliza el contenido con 'Editar'. Si prefieres trabajar en otra plataforma, usa 'Copiar' para llevar el texto donde desees."
    );
  }, []);

  return (
    <>
      <UmmiaAppsLayout
        onBack={handleBack}
        imageSrc={PlanificacionDiferenciadaCardImg}
        backgroundColorImage={
          "linear-gradient(180deg, #FFFFFF 0%, #A9D1C0 100%, #52A381 100%)"
        }
        titleColor="#278C62"
        title={t("claseDiferenciadaTitle")}
        description="Diseña tus lecciones integrando los apoyos educativos y ajustes necesarios para responder a los requerimientos y talentos de todos tus estudiantes"
        isButtonDisabled={isButtonDisabled}
        colorIconBack={colorIconBack}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            
              <CurriculumTabs
                nivelId={nivelId}
                materiaId={materiaId}
                nivelTPId={nivelTPId}
                asignaturaTPId={asignaturaTPId}
                handleNivelChange={handleNivelChange}
                handleNivelTPChange={handleNivelTPChange}
                handleAsignaturaChangeLocal={handleAsignaturaChangeLocal}
                handleAsignaturaTPChangeLocal={handleAsignaturaTPChangeLocal}
                clearTP={clearTP}
                promptData={promptData}
                setPromptData={setPromptData}
              />
          </Grid>
        </Grid>

        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <TemaClase />
        </Grid>

        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <TiempoClase promptData={promptData} setPromptData={setPromptData} />
        </Grid>

        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <Caracterizacion />
        </Grid>

        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <AjustesYApoyos />
        </Grid>

        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <CondicionesContexto />
        </Grid>
      </UmmiaAppsLayout>
    </>
  );
};

export default ClaseDiferenciadaPage;
